import { script } from './modules/script';